import { Button } from '@ui';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import HilbiAlert from '../../hilbi-alert';
import LoadingOverly from '../../loading-overlay';
import { ModalCopySC } from '../../modal/modal.styled';
import { ConfirmModalSC } from './patients-modals.styled';

type TProps = {
  loading: boolean;
  fullName: string;
  doctor: string;
  onConfirm(): void;
};

const ConfirmModal: React.FC<TProps> = ({ fullName, doctor, loading, onConfirm }) => {
  const { formatMessage } = useIntl();
  return (
    <ConfirmModalSC>
      <LoadingOverly loading={loading}>
        <ModalCopySC>
          <FormattedMessage id="patients_confirm_modal.copy" />
        </ModalCopySC>
        <div className="alert-margins">
          <HilbiAlert>
            <FormattedMessage
              id="patients_confirm_modal.message"
              values={{ doctor, name: fullName }}
            />
          </HilbiAlert>
        </div>
        <Button onClick={onConfirm}>
          {formatMessage({ id: 'patients_confirm_modal.submit' })}
        </Button>
      </LoadingOverly>
    </ConfirmModalSC>
  );
};

export default ConfirmModal;
